import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BatchReturnStatusType, ReturnStatusType } from 'returnCenter-api';
import type { RootState } from 'store';

export type TargetInputMode = 'search' | 'barcode' | 'customer';

export type ViewMode = 'returns' | 'batch-returns';

type NavigationState = {
    loading: boolean;
    selectedStatus: ReturnStatusType | null;
    selectedBatchStatus: BatchReturnStatusType | null;
    viewMode: ViewMode;
    currentView: string;
    origin: string | null;
    targetInputMode: TargetInputMode | null;
};

const initialState: NavigationState = {
    loading: false,
    currentView: 'default',
    selectedStatus: null,
    selectedBatchStatus: null,
    viewMode: 'returns',
    origin: null,
    targetInputMode: null,
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setCurrentView: (state, action: PayloadAction<string>) => {
            state.currentView = action.payload;
        },
        setSelectedStatus: (state, action: PayloadAction<ReturnStatusType | null>) => {
            state.selectedStatus = action.payload;
        },
        setSelectedBatchStatus: (state, action: PayloadAction<BatchReturnStatusType | null>) => {
            state.selectedBatchStatus = action.payload;
        },
        setViewMode: (state, action: PayloadAction<ViewMode>) => {
            state.viewMode = action.payload;
        },
        setOrigin: (state, action: PayloadAction<string | null>) => {
            state.origin = action.payload;
        },
        setTargetInputMode: (state, action: PayloadAction<TargetInputMode | null>) => {
            state.targetInputMode = action.payload;
        },
    },
});

export const selectCurrentView = (state: RootState) => state.navigation.currentView;
export const selectSelectedStatus = (state: RootState) => state.navigation.selectedStatus;
export const selectSelectedBatchStatus = (state: RootState) => state.navigation.selectedBatchStatus;
export const selectViewMode = (state: RootState) => state.navigation.viewMode;
export const selectOrigin = (state: RootState) => state.navigation.origin;
export const selectTargetInputMode = (state: RootState) => state.navigation.targetInputMode;

export const { setCurrentView, setSelectedStatus, setSelectedBatchStatus, setViewMode, setOrigin, setTargetInputMode } = navigationSlice.actions;
export default navigationSlice.reducer;
